import React, { FunctionComponent, memo } from "react";
import { components } from "react-select";
import { IndicatorComponentType } from "react-select/src/components";
import { IndicatorProps } from "react-select/src/components/indicators";

const RSClearIndicatorComponent = components.ClearIndicator as IndicatorComponentType<any>;

export const ClearIndicator: FunctionComponent<IndicatorProps<any>> = memo(props => {
  const ClearIcon = props.selectProps.icons.clear;

  return <RSClearIndicatorComponent {...props}>{ClearIcon}</RSClearIndicatorComponent>;
});
